import React from "react";
import { Container } from "./ui";
import { trustStats } from "../data/content";
export function TrustStrip() {
  return <section aria-label="Kit at a glance" className="bg-petrol-deep" data-id="element-226" data-mp="2o53xx0c6tnj7">
      <Container className="py-6 md:py-0" data-id="element-227" data-mp="2jckjy29l8qdv">
        <dl className="grid grid-cols-2 gap-px overflow-hidden border border-white/15 bg-white/15 md:grid-cols-4 md:border-y-0" data-id="element-228" data-mp="2jb9jabbfvyqz">
          {trustStats.map(s => <div key={s.label} className="flex flex-col items-center justify-center bg-petrol px-3 py-6 text-center md:py-9" data-id="element-229" data-mp="2aco1iidsknr9">
              <dt className="order-2 mt-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-white/85 sm:text-xs" data-id="element-230" data-mp="25bqdvqa0j1id">
                {s.label}
              </dt>
              <dd className="order-1 font-display text-[clamp(28px,8.5vw,40px)] font-extrabold uppercase leading-none text-sage md:text-[48px] lg:text-[52px]" data-id="element-231" data-mp="1wdeqdx4g0ju5">
                {s.value}
              </dd>
            </div>)}
        </dl>
      </Container>
    </section>;
}